import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
    width: "100%",
    flex: 1,
    minHeight: 0,
  },
  thumb: {
    position: "relative",
    width: "100%",
    flex: 1,
    minHeight: 120,
    background: "#FFFFFF",
    borderRadius: 6,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #E6EAEA",
  },
  media: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  pdfGlyph: {
    width: 64,
    height: 64,
    objectFit: "contain",
  },
  editBtn: {
    position: "absolute",
    top: 4,
    right: 4,
    background: "rgba(255,255,255,0.9)",
    color: "#3D63E6",
    padding: 4,
    "&:hover": {
      background: "rgba(255,255,255,1)",
    },
  },
  deleteBtn: {
    position: "absolute",
    top: 4,
    left: 4,
    background: "rgba(255,255,255,0.9)",
    color: "#F24474",
    padding: 4,
    "&:hover": {
      background: "rgba(255,255,255,1)",
    },
  },
  name: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: 13,
    color: "#2A3333",
    width: "100%",
    textAlign: "center",
  },
  size: {
    fontFamily: "Cairo",
    fontWeight: 400,
    fontSize: 11,
    color: "#6C7A7A",
  },
}));
